export const NAVBAR_HIDDEN_PATHS = [
  "/submit/",
  "/preview-rfp/",
  "/get-started",
  "/login",
  "/onboarding",
  "/review_system",
  "/opportunities",
];

export const NAVBAR_BORDER_PATHS = [
  "/inbox",
  "/account",
  "/reviewer_dashboard",
  "/reviewer_dashboard/teams",
  "/reviewer_dashboard/proposals",
  "/proposal_library",
  "/network",
  "/startup_program",
  "/request_for_experts",
  "/universities",
  "/discover",
  "/solution_listings",
];
